import { Injectable } from "@angular/core";
@Injectable()
export class AppEnums {
	static readonly ElementTipleri = {
		label: "label",
		input: "input",
		dovizKuru: "dovizKuru",
		dovizMiktari: "dovizMiktari",
		dovizKarsiligi: "dovizKarsiligi",
		birimCombo: "birimCombo",
		islemler: "islemler",
		ihracatFaturaTeslimatBilgisi: "ihracatFaturaTeslimatBilgisi",
		vergiInput: "vergiInput",
		oranInput: "oranInput",
		bsmvOranInput: "bsmvOranInput",
		fiyatInput: "fiyatInput",
		istisnaCombo: "istisnaCombo",
		iskontoTuru: "iskontoTuru",
		iskontoOrani: "iskontoOrani",
		iskontoTutari: "iskontoTutari",
		stopajOrani: "stopajOrani",
		stopajTutari: "stopajTutari",
		kdvTutari: "kdvTutari",
		bsmvTutari: "bsmvTutari",
		malHizmetTutari: "malHizmetTutari",
		vergisizMalHizmetTutari: "vergisizMalHizmetTutari",
		esmmHizmetTutari: "esmmHizmetTutari",
		miktarInput: "miktarInput",
		gonderilecekMiktarInput: "gonderilecekMiktarInput",
		fazlaMiktarInput: "fazlaMiktarInput",
		esmmHesaplamaTipi: "esmmHesaplamaTipi",
		currencyLabel: "currencyLabel",
		esmmBrutKdvHaric: "esmmBrutKdvHaric",
		esmmStopajTutari: "esmmStopajTutari",
		esmmAlinanNetUcret: "esmmAlinanNetUcret",
		esmmBrutUzerindenKdv: "esmmBrutUzerindenKdv",
		esmmTahsilEdilen: "esmmTahsilEdilen",
		esmmKdvOrani: "esmmKdvOrani",
		esmmKdvTevkifatOrani: "esmmKdvTevkifatOrani",
		esmmKdvTevkifatTutari: "esmmKdvTevkifatTutari",
		esmmStopajOrani: "esmmStopajOrani",
		ParaBirimCombo: "ParaBirimCombo",
		odemeSekliCombo: "odemeSekliCombo",
		mevcutParaBirimCombo: "mevcutParaBirimCombo",
		aliciKodu: "aliciKodu",
		saticiKodu: "saticiKodu",
		ureticiKodu: "ureticiKodu",
		sarjUnitesiSeriNumarasi: "sarjUnitesiSeriNumarasi",
		urunNumarasi: "urunNumarasi",
		partiNumarasi: "partiNumarasi",
		siraNumarasi: "siraNumarasi",
		uretimTarihi: "uretimTarihi",
		ilacUrunNumarasi: "ilacUrunNumarasi",
		ilacPartiNumarasi: "ilacPartiNumarasi",
		ilacSiraNumarasi: "ilacSiraNumarasi",
		ilacSonKullanmaTarihi: "ilacSonKullanmaTarihi",
		labelIlacTibbiCihaz: "labelIlacTibbiCihaz",
		teknolojiDestekMobil: "teknolojiDestekMobil",
		teknolojiDestekTabletPc: "teknolojiDestekTabletPc",
		teknolojiDestekCombo: "teknolojiDestekCombo",
		yerlilikOrani: "yerlilikOrani",
		sasKalemNo: "sasKalemNo",
		malzHizmetKodu: "malzHizmetKodu",
		malzHizmetTanimi: "malzHizmetTanimi",
		saticiDIIBKodu: "saticiDIIBKodu",
		aliciDIIBKodu: "aliciDIIBKodu",
		harcamaTipiKodu: "harcamaTipiKodu",
		makineAdi: "makineAdi",
		makineId: "makineId",
		makineSiraNo: "makineSiraNo",

	};

	static readonly TransferFaturaYuklemeTipleri = {
		eArsiv: "E-Arsiv",
		gelenFatura: "Gelen Fatura",
		gidenFatura: "Giden Fatura",
	};

	static readonly;
}

export enum Months {
	ocak = 1,
	subat = 2,
	mart = 3,
	nisan = 4,
	mayis = 5,
	haziran = 6,
	temmuz = 7,
	agustos = 8,
	eylul = 9,
	ekim = 10,
	kasim = 11,
	aralik = 12,
}

export enum FaturaDurumlari {
	hazirlaniyor = -1, // Back-endde karşılığı yok, henüz db kaydı oluşmadı anlamında.
	taslak = 1,
	onaylandi = 2,
	iptal = 3,
	hatali = 4,
	kuyrukta = 5,
	gibeGonderildi = 6,
	imzalandi = 7,
	raporKuyrugunda = 8,
	raporGibeGonderildi = 9,
	itiraz = 10,
}

export enum ItirazTipleri {
	noterAraciligiyla = 1,
	tahahhutluMektup = 2,
	telgraf = 3,
	kep = 4,
}

export enum KepDurumlari {
	gonderildi = 1,
	iletildi = 2,
	okundu = 3,
	kabuledildi = 4,
	reddedildi = 5,
	hatali = 6,
}

export enum EBuroGibDurumlari {
	pasif = 0,
	aktif = 1,
	basvuruldu = 2,
	basarisiz = 3,
	gibGonderimiBasarisiz = 4,
	iptal = 10,
}

export enum RaporDurumlari {
	DosyaKuyrukta = 1,
	PaketIslenmeyeBaslandi = 2,
	PaketBasariylaIslendi = 3,
	AyniPaketID = 4,
	DosyaOkunamadi = 5,
	ZipDosyasiAcilamadi = 6,
	PaketteBirdenFazlaDosyaVar = 7,
	ImzaDogrulanamadi = 8,
	BaslikXMLValidasyonHatasiAciklamasi = 9,
	UyumsuzDokumanVersiyonTipi = 10,
	XMLValidasyonHatasiAciklamasi = 11,
	BaslikPaketIDilePaketAdlandirilmasiUyumsuz = 12,
	ImzaBulunamadi = 13,
	XMLVeritabaniYazimHatasi = 14,
	OkumaHatasi = 15,
	VeriTabaniHatasi = 16,
	SistemHatasi = 17,
	PaketteDosyaYok = 18,
	MaxDosyaBoyutuHatasi = 19,
	IstekImzasivePaketImzasiUyusmuyor = 20,
	ImzaSahibiileHazirlayanVKNTCKNuyusmuyor = 21,
	GondericininBuMukellefinEarsivRaporunuIsletmeYetkisiYok = 22,
}

export enum FaturaTurleri {
	satis = 1,
	iade = 2,
	tevkifat = 4,
	istisna = 8,
	ozelMatrah = 16,
	ihracKayitli = 32,
	sgk = 64,
	konaklama = 128,
	sarj = 257,
	sarjAnlik = 258,
	ilac = 512,
	tibbiCihaz = 513,
	teknolojiDestek = 1024,
	ytbSatis = 1028,
	ytbIade = 1032,
	ytbIstisna = 1036,
	ytbTevkifat = 1040,
	ytbTevfikatIade = 1048,
}

export enum SgkFaturaTurleri {
	eczane = 1,
	hastane = 2,
	optik = 3,
	medikal = 4,
	abonelik = 5,
	malHizmet = 6,
	diger = 7,
}

export enum FaturaTipleri {
	earsiv = 1,
	efatura = 2,
	emm = 3,
	esmm = 4,
	eirsaliye = 6,
	eDoviz = 12,
	eAdisyon = 13,
	eSigorta = 15,
}

export enum FaturaKayitTipleri {
	GIBGonder = 1,
	TaslakKaydet = 2
}

export enum EDovizBelgeTipleri {
	eDovizAlim = 1,
	eDovizSatim = 2,
}

export enum IrsaliyeTipleri {
	sevk = 1,
}
export enum IrsaliyeCevapDurumlari {
	KABUL = 1,
	KISMI_KABUL = 2,
	CEVAP_VERILMEDI = 3,
	RED_EDILDI = 5
}

export enum XsltTipleri {
	eArsivGenel = 1,
	eArsivInternet = 2,
	eFaturaGenel = 3,
	eSMMGenel = 4,
	eIrsaliyeGenel = 5,
	eIrsaliyeYanit = 6,
}

export enum BelgeDosyaTanimlari {
	Tümü = 0,
	FATURA_XML = 1,
	FATURA_PDF = 2,
	RAPOR_XML = 3,
	EARSIV_GENEL_XSLT = 4,
	EARSIV_INTERNET_XSLT = 5,
	GELEN_FATURA_GECICI_XML = 6,
	GELEN_FATURA_GECICI_PAKET = 7,
	GIDEN_FATURA_KABUL_RED_PAKET = 8,
	EFATURA_GENEL_XSLT = 9,
}

export enum SenaryoTurleri {
	TemelFatura = 1,
	TicariFatura = 2,
	IhracatFatura = 3,
	YolcuBeraberFatura = 4,
	TemelIrsaliye = 5,
	Kamu = 6,
	Enerji = 7,
	Edoviz = 8,
	KiymetliMaden = 9,
	YatirimTesvik = 11
}

export enum IskontoHesaplamaTipleri {
	Tutar = 1,
	Oran = 2,
}

export enum EKontrolNoktasiSUID {
	Select = 1,
	Update = 2,
	Insert = 4,
	Delete = 8,
	Tanimsiz = 0,
}

export enum GonderimSekilleri {
	Kagıt = 1,
	Elektronik = 2,
}

export enum KullaniciDurumlari {
	Aktif = 1,
	Pasif = 2,
}

export enum KullaniciTipleri {
	SuperAdmin = 1,
	Admin = 2,
	Kullanici = 3,
	Izleyici = 4,
	Bayi = 5,
}

export enum ParaBirimleri {
	TurkLirasi = 1,
	Euro = 2,
	Dolar = 3,
	Sterlin = 4,
}

export enum BirimKodlari {
	ADET = 1,
	KWH = 26,
}

export enum KisiTipleri {
	GercekKisi = 1,
	TuzelKisi = 2,
}

export enum HesaplamaTipleri {
	TahsilEdilenden = 1,
	BrutUzerinden = 2,
	NetUzerinden = 3,
}

export enum Ilac_tibbiCihaz {
	Ilac = 1,
	TibbiCihaz = 2,
}
export enum TeknolojiDestekTurleri {
	MOBIL = 1,
	TABLET_PC = 2,
}

export enum ESMMHizmetTurleri {
	Genel = 1,
	Cmk = 2,
	AdliYardim = 3,
	TarifeUzerinden = 4,
	Arabuluculuk = 5,
	Gider = 6
}

export enum InternetOdemeSekilleri {
	KrediKartiBankaKarti = 1,
	EftHavale = 2,
	KapidaOdeme = 3,
	OdemeAracisiIle = 4,
	Diger = 5,
}
export enum OdemeSekilleri {
	Nakit = 1,
	KrediKarti = 2,
	Cek = 3,
	Senet = 4,
	Havale = 5,
	AcikHesap = 6,
}
export enum EarsivXsltTipleri {
	genel = 1,
	internet = 2,
}

export enum OnTanimTipleri {
	aciklama = 1,
}

export enum VergiTurleri {
	GelirVergisiStopaji = 1,
	KurumlarVergisiStopaji = 2,
	PetrolDogalgazOtv = 5,
	PetrolDogalgazOtvTevkifati = 16,
	BorsaTescilUcreti = 17,
	KdvTevkifati = 24,
	MeraFonu = 26,
	MotorluTasitAraclarinaIliskinOTV = 27,
	DigerKdvTevkifati650 = 57,
	SGK_PRIM = 93,
}

export enum Ulkeler {
	Turkiye = 1,
}

export enum Istisnalar {
	Kodu209BankaSigortaMuameleleriIstisnasi = 16,
	Kodu223TeknolojiGelistirmeBolgeIstisnasi = 28,
	Kodu301MalIhracati = 46,
	Kodu501YolcuBeraberiEsya = 81,
	KDVIstisnaOlmayanDiger351 = 80,
	Kodu801 = 82,
	Kodu802 = 83,
	Kodu803 = 84,
	Kodu804 = 85,
	Kodu805 = 86,
	Kodu806 = 87,
	Kodu807 = 88,
	Kodu808 = 89,
	Kodu809 = 90,
	Kodu810 = 91,
	Kodu811 = 92,
	Kodu812 = 93,
	Kodu702 = 103,
	Kodu335BasiliKitapSureliYayinlarinTeslimleri = 94,
}

export enum EFaturaCevapDurumlari {
	KABUL = 1,
	RED = 2,
	IADE = 4,
	S_APR = 8,
	CEVAP_VERILMEDI = 16,
	KEP_ILE_REDDEDILDI = 99,
}

export enum GIBFaturaDurumlari {
	ZarfKuyrugaEklendi = 1,
	ZarfIsleniyor = 2,
	ZipDosyasiDegil = 3,
	ZarfIdUzunluguGecersiz = 4,
	ZarfArsivdenKopyalanamadi = 5,
	ZipAcilamadi = 6,
	ZipBirDosyaIcermeli = 7,
	XmlDosyasiDegil = 8,
	ZarfIdveXmlDosyasininAdiAyniOlmali = 9,
	DokumanAyristirilamadi = 10,
	ZarfIdYok = 11,
	ZarfIdveZipDosyasiAdiAyniOlmali = 12,
	GecersizVersiyon = 13,
	SchematronKontrolSonucuHatali = 14,
	XmlSemaKontrolundenGecemedi = 15,
	ImzaSahibiTcknVknAlinamadi = 16,
	ImzaKaydedilemedi = 17,
	GonderilenZarfSistemdeDahaOnceKayitliOlanBirFaturayiIcermektedir = 18,
	YetkiKontrolEdilemedi = 19,
	GondericiBirimYetkisiYok = 20,
	PostaKutusuYetkisiYok = 21,
	ImzaYetkisiKontrolEdilemedi = 22,
	ImzaSahibiYetkisiz = 23,
	GecersizImza = 24,
	AdresKontrolEdilemedi = 25,
	AdresBulunamadi = 26,
	KullaniciEklenemedi = 27,
	KullaniciSilinemedi = 28,
	SistemYanitiHazirlanamadi = 29,
	SistemHatasi = 30,
	ZarfBasariylaIslendi = 31,
	DokumanBulunanAdreseGonderilemedi = 32,
	DokumanGonderimiBasarisizSonlandi = 33,
	HedeftenSistemYanitiGelmedi = 34,
	HedeftenSistemYanitiBasarisizGeldi = 35,
	BasariylaTamamlandi = 36,
	ZarfIdBulunamadi = 37,
}

export enum AktarimTipleri {
	earsiv = 1,
	efatura = 2,
	emm = 3,
	esmm = 4,
	ihracatfatura = 5,
	cari = 6,
}

export enum Formlar {
	faturaKayit = 13,
	raporKayit = 19,
	eirsaliyekayit = 49,
}

export enum LoginTipleri {
	turkFatura = 1,
	makbuzTek = 2,
	turkMakbuz = 3,
}

export enum ApplicationTipleri {
	Unidox = 8
}

export enum AnahtarDeger {
	ArdSignerVersiyon = 1,
}

export enum MuhasebeciMaliMusavirGoruntulemeAyarlari {
	GonderilenMakbuzFaturalariGorebilir = 1,
	TumMakbuzFaturalariGorebilir = 2,
}

export enum MuhasebeciMaliMusavirMailGonderimPeriyodlari {
	Aylik = 1,
	UcAylik = 2,
	Yillik = 3,
}

export enum KepTanimlari {
	FaturaItiraz = 1,
	MakbuzIptal = 2,
	MakbuzGonderim = 3,
	ManuelGonderim = 4,
}

export enum DuyuruTanimlari {
	AnasayfaDuyuru = 1,
	PopupDuyuru = 2,
}

export enum BuroLogoImzaOlcekTipleri {
	Kucuk = 1,
	Orta = 2,
	Buyuk = 3,
	Maksimum = 4,
}

export enum EFaturaCevaplamaSekilleri {
	Tekli = 1,
	Coklu = 2,
}

export enum TalepDurumlari {
	degerlendiriliyor = 1,
	islemealindi = 2,
	sonuclandi = 3,
	kapatildi = 4,
	iptal = 5,
}

export enum GeriDonusSaglamaTipleri {
	eposta = 1,
	sms = 2,
	telefon = 3,
}

export enum TalepKategorileri {
	diger = -1,
}

export enum TalepTipleri {
	diger = -1,
}

export enum DisModuller {
	Icratek = 1,
	Burotek = 2,
	Ocas = 3,
	Uhap = 4,
	Karartek = 5,
	ZirveMuhasebe = 6,
	Otomini = 7,
	Diger = 8,
	Paribu = 9,
	TurkFatura = 10,
	MakbuzTek = 11,
	TurkMakbuz = 12,
	Excel = 13,
	Pavo = 14,
	Aspower = 15,
	Ardventure = 16,
	Imzatek = 17,
	MedulaPdf = 18,
}

export enum GoruntulemeTipleri {
	EFatura_Default_Gib_Xslt = 1,
	Esmm_Eng_Xslt = 2,
	EIrsaliye_Default_Xslt = 3,
}

export enum TahsilatTipleri {
	ElektronikTahsilatSistemi = 0,
	Manuel = 1,
}

export enum MeslekTipleri {
	Muhendis = 9,
	VeterinerHekim = 17,
	OrmanMuhendisligi = 51, // Muhendisin alt meslek tipi
	OrmanEndustriMuhendisligi = 52, // Muhendisin alt meslek tipi
}

export enum RaporExportTypes {
	pdf = 0,
	html = 1,
	png = 2,
	xls = 3,
	doc = 4,
	tiff = 5,
	xlsx = 6,
}

export enum EExcelExportRaporTipleri {
	BasitFatura = 1,
	DetayliFatura = 2,
	DovizBasitDetayli = 3,
	DovizDetayliFatura = 4,
}

export enum EExcelExportSiralamaTipleri {
	FATURA_TARIHI = 1,
	ODENECEK_TUTAR = 2,
	FATURA_NO = 3,
	UNVANI = 4
}

export enum EIndirmeTipleri {
	TekPdf = 1,
	PdfleriZiple = 2
}
